<template>
    <b-modal
        :hide-footer="true"
        :title="$t('Mais informações do Cad Único')"
        centered
        size="xl"
        id="mais-info"
    >
        <div class="row">
            <div class="col-md-12">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>
                                Data da entrevista:
                                {{ $parent.item.data_entrevista }}
                            </th>
                            <th>
                                Nome do entrevistador:
                                {{ $parent.item.nome_entrevistador }}
                            </th>
                            <th>
                                CPF do entrevistador:
                                {{ $parent.item.cpf_entrevistador }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="3">
                                <p>Observação apontadas pelo entrevistador</p>
                                {{ $parent.item.observacoes }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {};
    },
    methods: {
        submit() {},
    },
};
</script>
